module.exports = __webpack_public_path__ + "img/ve.98340c92.svg";